
import React from 'react'
import DashBody from '../../Layout/Dashboard/DashBody'
import DashHeader from '../../Layout/Dashboard/DashHeader'
import LyTable from '../../Layout/Dashboard/LyTable'
import useTableColumns from './useTableColumns'
import { useGetSocialMedia} from '../../api/SocialMedia'
import { QueryStatusEnum } from '../../config/QueryStatus'
import EditSocialMediaModal from './EditSocialMediaModal'
import AddSocialMediaModal from './AddSocialMediaModal'

function SocialMediaPage() {

    const column   =useTableColumns()
    const {data  ,status } = useGetSocialMedia()

    
  return (
    // Pass Status to Layout 
    <DashBody status={status as QueryStatusEnum} >
      <DashHeader title={'SocialMedia'}></DashHeader>
      
      <LyTable
        data={data}
        isLoading={false}
        columns={column}
      />
      
      <EditSocialMediaModal />
      <AddSocialMediaModal />
      
    </DashBody>
  )
}

export default SocialMediaPage

